import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ErrorPage = ({ message }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <Box
      minHeight="95vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      sx={{
        backgroundColor: theme.palette.background.paper,
        padding: 3,
        borderRadius: 2,
        boxShadow: `0px 2px 12px ${theme.palette.grey[500]}`,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: "red" }} />
      <Typography variant="h4" sx={{ mt: 2 }}>
        Oops! Something went wrong.
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        {message || "An unexpected error occurred. Please try again later."}
      </Typography>
      <Button
        variant="contained"
        color="error"
        onClick={handleGoBack}
        sx={{ mt: 4, textTransform: "none", fontWeight: "bold" }}
      >
        Go Back
      </Button>
    </Box>
  );
};

export default ErrorPage;
